import { adminFetch } from "./userApi";

export interface Tenant {
  tenant_id:      string;
  name:           string;
  slug:           string;
  plan:           string;
  status:         string;
  owner_user_sub: string;
}

export interface TenantMember {
  sub:       string;
  email:     string;
  role:      "owner" | "admin" | "member";
  joined_at: string;
}

export interface OAuthApp {
  provider:          string;
  client_id_masked:  string;
  display_name?:     string;
  scopes_allowlist?: string[];
  created_at:        string;
}

export const tenantApi = {
  getMe: (): Promise<Tenant> =>
    adminFetch("GET", "/admin/tenant/me"),

  create: (name: string, slug: string, plan?: string): Promise<Tenant> =>
    adminFetch("POST", "/admin/tenant", { name, slug, ...(plan ? { plan } : {}) }),

  listMembers: (): Promise<TenantMember[]> =>
    adminFetch("GET", "/admin/tenant/members"),

  invite: (email: string, role: "admin" | "member"): Promise<{ invite_token: string }> =>
    adminFetch("POST", "/admin/tenant/invite", { email, role }),

  removeMember: (sub: string): Promise<void> =>
    adminFetch("DELETE", `/admin/tenant/members/${encodeURIComponent(sub)}`),

  listOAuthApps: (): Promise<OAuthApp[]> =>
    adminFetch("GET", "/admin/oauth/apps"),

  setOAuthApp: (
    provider: string,
    clientId: string,
    clientSecret: string,
    displayName?: string,
    scopesAllowlist?: string[],
  ): Promise<void> =>
    adminFetch("POST", `/admin/oauth/apps/${encodeURIComponent(provider)}`, {
      client_id:     clientId,
      client_secret: clientSecret,
      ...(displayName      ? { display_name:      displayName }      : {}),
      ...(scopesAllowlist  ? { scopes_allowlist:   scopesAllowlist }  : {}),
    }),

  removeOAuthApp: (provider: string): Promise<void> =>
    adminFetch("DELETE", `/admin/oauth/apps/${encodeURIComponent(provider)}`),
};
